import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3652c1a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home-container"
}
const _hoisted_2 = { class: "app__title" }
const _hoisted_3 = { class: "loading-speakers mb-1" }
const _hoisted_4 = { style: {"padding":"14px"} }
const _hoisted_5 = { style: {"padding":"14px"} }
const _hoisted_6 = {
  key: 0,
  class: "speaker-center"
}
const _hoisted_7 = { class: "truncate-name" }
const _hoisted_8 = { class: "title-text truncate-text black__base__color" }
const _hoisted_9 = { class: "justify-text gray__base__color" }
const _hoisted_10 = { class: "time-program mt-1" }
const _hoisted_11 = { class: "ma-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-1" }, "-", -1))
const _hoisted_13 = { class: "ma-0" }
const _hoisted_14 = { class: "ma-0" }
const _hoisted_15 = {
  key: 2,
  class: "speaker-card-only speaker-center"
}
const _hoisted_16 = { class: "truncate-name" }
const _hoisted_17 = { class: "title-text truncate-text" }
const _hoisted_18 = { class: "truncate-vertical description__justify" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppMainSpeaker = _resolveComponent("AppMainSpeaker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_ctx.eventData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AppMainSpeaker, { programsData: _ctx.programsData }, null, 8, ["programsData"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              class: "app__header__title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("speakers.title")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("speakers.title")), 1)
              ]),
              _: 1
            }),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  xs: 24,
                  sm: 24,
                  md: 12,
                  lg: 6,
                  xl: 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_skeleton, {
                      style: {"height":"350px"},
                      loading: _ctx.loading,
                      animated: ""
                    }, {
                      template: _withCtx(() => [
                        _createVNode(_component_el_card, { class: "speaker-center" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("speakers.loading")), 1),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "circle ",
                              style: {"width":"120px","height":"120px"}
                            }),
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_el_skeleton_item, {
                                variant: "h3",
                                style: {"width":"50%"}
                              }),
                              _createVNode(_component_el_skeleton_item, { variant: "text" }),
                              _createVNode(_component_el_skeleton_item, { variant: "text" }),
                              _createVNode(_component_el_skeleton_item, { variant: "text" }),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "h1",
                                style: {"width":"50%"},
                                class: "mt-2"
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programsData, (speaker, speakerKey) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 12,
                lg: 6,
                xl: 4,
                key: speakerKey,
                class: "my-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_skeleton, {
                    style: {"height":"320px"},
                    loading: _ctx.loading,
                    animated: ""
                  }, {
                    template: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "speaker-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle ",
                            style: {"width":"120px","height":"120px"}
                          }),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "h3",
                              style: {"width":"50%"}
                            }),
                            _createVNode(_component_el_skeleton_item, { variant: "text" }),
                            _createVNode(_component_el_skeleton_item, { variant: "text" }),
                            _createVNode(_component_el_skeleton_item, { variant: "text" }),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "h1",
                              style: {"width":"50%"},
                              class: "mt-2"
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_tabs, {
                        type: "border-card",
                        "tab-position": "bottom",
                        id: "speaker-tabs",
                        class: "tab-card"
                      }, {
                        default: _withCtx(() => [
                          (Object.keys(_ctx.programsData).length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("speakers.notFound")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (speaker.dates)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(speaker.dates, (programData, date, index) => {
                                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                                  label: date,
                                  class: "speaker-center",
                                  key: date
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["speaker-container", {
                      'scroll-y': Object.keys(programData).length > 1,
                    }])
                                    }, [
                                      _createElementVNode("div", {
                                        class: "speaker-name-tag",
                                        style: _normalizeStyle({ backgroundColor: _ctx.colors[index] })
                                      }, [
                                        _createElementVNode("p", _hoisted_7, _toDisplayString(speaker.speakerName), 1)
                                      ], 4),
                                      _createVNode(_component_el_avatar, {
                                        class: "speaker-avatar",
                                        style: _normalizeStyle({ border: `2px solid ${_ctx.colors[index]}` }),
                                        size: 100,
                                        src: 
                        speaker.picture
                          ? speaker.picture
                          : require('@/assets/no_profile_image.png')
                      
                                      }, null, 8, ["style", "src"]),
                                      _createElementVNode("p", _hoisted_8, _toDisplayString(speaker.title), 1),
                                      _createElementVNode("p", _hoisted_9, _toDisplayString(speaker.description), 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(programData, (program, programIndex) => {
                                        return (_openBlock(), _createElementBlock("div", { key: programIndex }, [
                                          _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("span", _hoisted_11, _toDisplayString(program.startTime), 1),
                                            _hoisted_12,
                                            _createElementVNode("span", _hoisted_13, _toDisplayString(program.endTime), 1)
                                          ]),
                                          _createElementVNode("h4", _hoisted_14, _toDisplayString(program.eventName), 1)
                                        ]))
                                      }), 128))
                                    ], 2)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", {
                                  class: "speaker-name-tag",
                                  style: _normalizeStyle({ backgroundColor: _ctx.colors[0] })
                                }, [
                                  _createElementVNode("p", _hoisted_16, _toDisplayString(speaker.speakerName), 1)
                                ], 4),
                                _createVNode(_component_el_avatar, {
                                  class: "speaker-avatar",
                                  style: _normalizeStyle({ border: `2px solid ${_ctx.colors[_ctx.index]}` }),
                                  size: 100,
                                  src: 
                    speaker.picture
                      ? speaker.picture
                      : require('@/assets/no_profile_image.png')
                  
                                }, null, 8, ["style", "src"]),
                                _createElementVNode("p", _hoisted_17, _toDisplayString(speaker.title), 1),
                                _createElementVNode("p", _hoisted_18, _toDisplayString(speaker.description), 1)
                              ]))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["loading"])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_ctx.renderLimit)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 1,
                  class: "speaker-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "secondary__color__button",
                      onClick: _ctx.goToSpeakers
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("speakers.viewMore")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}